import _defineProperty from "@babel/runtime/helpers/defineProperty";
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css } from '@emotion/react';
import { CodeBlockSharedCssClassName } from '@atlaskit/editor-common/styles';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var findReplaceStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match': {
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    boxShadow: "var(--ds-shadow-raised, 0 1px 1px 0 rgba(9, 30, 66, 0.25), 0 0 1px 0 rgba(9, 30, 66, 0.31))".concat(", inset 0 0 0 1px ", "var(--ds-border-input, #8C8F97)")
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.selected-search-match': {
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var findReplaceStylesWithCodeblockColorContrastFix = css(_defineProperty({}, ".".concat(CodeBlockSharedCssClassName.CODEBLOCK_CONTAINER, " .search-match.selected-search-match"), {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  span: {
    // we need to use !important here as we need to override inline selection styles
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    color: "var(--ds-text, #292A2E)".concat(" !important")
  }
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var findReplaceStylesNewWithCodeblockColorContrastFix = css(_defineProperty({}, ".".concat(CodeBlockSharedCssClassName.CODEBLOCK_CONTAINER, " .search-match-text.selected-search-match"), {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  span: {
    // we need to use !important here as we need to override inline selection styles
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    color: "var(--ds-text, #292A2E)".concat(" !important")
  }
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var findReplaceStylesNew = css({
  /** Text match styles */

  /** Light mode */

  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-text': {
    borderRadius: "var(--ds-space-050, 4px)",
    boxShadow: "\n\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-subtler-pressed, #F797D2)", ",\n\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-subtler, #FDD0EC)", "\n\t\t"),
    // we need to use !important here as we need to override inline selection styles
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)".concat(" !important"),
    color: "var(--ds-text, #292A2E)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-text.selected-search-match': {
    boxShadow: "\n\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-subtler-pressed, #F797D2)", ",\n\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)", "\n\t\t"),
    // we need to use !important here as we need to override inline selection styles
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    backgroundColor: "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)".concat(" !important")
  },
  /** Dark mode */

  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-text.search-match-dark': {
    boxShadow: "\n\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-bolder, #AE4787)", ",\n\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-bolder-pressed, #77325B)", "\n\t\t"),
    // we need to use !important here as we need to override inline selection styles
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    backgroundColor: "var(--ds-background-accent-magenta-bolder-pressed, #77325B)".concat(" !important"),
    color: "var(--ds-text-inverse, #FFFFFF)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-text.selected-search-match.search-match-dark': {
    boxShadow: "\n\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-bolder, #AE4787)", ",\n\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-bolder-hovered, #943D73)", "\n\t\t"),
    // we need to use !important here as we need to override inline selection styles
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    backgroundColor: "var(--ds-background-accent-magenta-bolder-hovered, #943D73)".concat(" !important")
  },
  /** Block match styles */

  /** Light mode */

  /** Without node selection */
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-block': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-smart-link-container="true"], .loader-wrapper>div::after': {
      boxShadow: "\n\t\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-subtler-pressed, #F797D2)", ",\n\t\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-subtler, #FDD0EC)", "\n\t\t\t")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
      boxShadow: "0px 0px 0px 4px ".concat("var(--ds-background-accent-magenta-subtler, #FDD0EC)", ", 0px 0px 0px 5px ", "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)")
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-block.search-match-block-selected': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-smart-link-container="true"], .loader-wrapper>div::after': {
      boxShadow: "\n\t\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-subtler-pressed, #F797D2)", ",\n\t\t\tinset 0 0 0 4px ", "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)", "\n\t\t\t")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
      boxShadow: "0px 0px 0px 4px ".concat("var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)", ", 0px 0px 0px 5px ", "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)")
    }
  },
  /** With node selection */
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-block.ak-editor-selected-node': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.loader-wrapper>div::after': {
      boxShadow: "\n\t\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-subtler-pressed, #F797D2)", ",\n\t\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-subtler, #FDD0EC)", ",\n\t\t\t0 0 0 1px ", "var(--ds-border-selected, #1868DB)", "\n\t\t\t")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
      boxShadow: "0 0 0 1px ".concat("var(--ds-border-selected, #1868DB)", ", 0px 0px 0px 4px ", "var(--ds-background-accent-magenta-subtler, #FDD0EC)", ", 0px 0px 0px 5px ", "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)")
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-block.search-match-block-selected.ak-editor-selected-node': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-smart-link-container="true"], .loader-wrapper>div::after': {
      boxShadow: "\n\t\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-subtler-pressed, #F797D2)", ",\n\t\t\tinset 0 0 0 4px ", "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)", ",\n\t\t\t0 0 0 1px ", "var(--ds-border-selected, #1868DB)", "\n\t\t\t")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
      boxShadow: "0 0 0 1px ".concat("var(--ds-border-selected, #1868DB)", ", 0px 0px 0px 4px ", "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)", ", 0px 0px 0px 5px ", "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)")
    }
  },
  /** Dark mode */
  /** Without node selection */
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-block.search-match-dark': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-smart-link-container="true"], .loader-wrapper>div::after': {
      boxShadow: "\n\t\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-bolder, #AE4787)", ",\n\t\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-bolder-pressed, #77325B)", "\n\t\t\t")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
      boxShadow: "0px 0px 0px 4px ".concat("var(--ds-background-accent-magenta-bolder-pressed, #77325B)", ", 0px 0px 0px 5px ", "var(--ds-background-accent-magenta-bolder, #AE4787)")
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-block.search-match-block-selected.search-match-dark': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-smart-link-container="true"], .loader-wrapper>div::after': {
      boxShadow: "\n\t\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-bolder, #AE4787)", ",\n\t\t\tinset 0 0 0 4px ", "var(--ds-background-accent-magenta-bolder-hovered, #943D73)", "\n\t\t\t")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
      boxShadow: "0px 0px 0px 4px ".concat("var(--ds-background-accent-magenta-bolder-hovered, #943D73)", ", 0px 0px 0px 5px ", "var(--ds-background-accent-magenta-bolder, #AE4787)")
    }
  },
  /** With node selection */
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-block.search-match-dark.ak-editor-selected-node': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.loader-wrapper>div::after': {
      boxShadow: "\n\t\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-bolder, #AE4787)", ",\n\t\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-bolder-pressed, #77325B)", ",\n\t\t\t0 0 0 1px ", "var(--ds-border-selected, #1868DB)", "\n\t\t\t")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
      boxShadow: "0 0 0 1px ".concat("var(--ds-border-selected, #1868DB)", ", 0px 0px 0px 4px ", "var(--ds-background-accent-magenta-bolder-pressed, #77325B)", ", 0px 0px 0px 5px ", "var(--ds-background-accent-magenta-bolder, #AE4787)")
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-block.search-match-block-selected.search-match-dark.ak-editor-selected-node': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-smart-link-container="true"], .loader-wrapper>div::after': {
      boxShadow: "\n\t\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-bolder, #AE4787)", ",\n\t\t\tinset 0 0 0 4px ", "var(--ds-background-accent-magenta-bolder-hovered, #943D73)", ",\n\t\t\t0 0 0 1px ", "var(--ds-border-selected, #1868DB)", "\n\t\t\t")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.loader-wrapper>a, .hover-card-trigger-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
      boxShadow: "0 0 0 1px ".concat("var(--ds-border-selected, #1868DB)", ", 0px 0px 0px 4px ", "var(--ds-background-accent-magenta-bolder-hovered, #943D73)", ", 0px 0px 0px 5px ", "var(--ds-background-accent-magenta-bolder, #AE4787)")
    }
  },
  /** Expand title match styles */

  /** Light mode */

  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-expand-title > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
    borderRadius: "var(--ds-space-050, 4px)",
    boxShadow: "\n\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-subtler-pressed, #F797D2)", ",\n\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-subtler, #FDD0EC)", "\n\t\t"),
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__title-input': {
      color: "var(--ds-text, #292A2E)"
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-expand-title.selected-search-match > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
    boxShadow: "\n\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-subtler-pressed, #F797D2)", ",\n\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)", "\n\t\t"),
    backgroundColor: "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)"
  },
  /** Dark mode */

  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-expand-title.search-match-dark > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
    boxShadow: "\n\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-bolder, #AE4787)", ",\n\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-bolder-pressed, #77325B)", "\n\t\t"),
    backgroundColor: "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__title-input': {
      color: "var(--ds-text-inverse, #FFFFFF)"
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.search-match-expand-title.selected-search-match.search-match-dark > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
    boxShadow: "\n\t\tinset 0 0 0 1px ".concat("var(--ds-background-accent-magenta-bolder, #AE4787)", ",\n\t\tinset 0 0 0 5px ", "var(--ds-background-accent-magenta-bolder-hovered, #943D73)", "\n\t\t"),
    backgroundColor: "var(--ds-background-accent-magenta-bolder-hovered, #943D73)"
  }
});